import { ReactElement, ReactNode } from 'react'
import {
  List,
  MenuItem,
  ListItemIcon,
  Typography,
  Collapse
} from '@mui/material'
import ExpandMore from '@mui/icons-material/ExpandMore'
import ExpandLess from '@mui/icons-material/ExpandLess'
import { useTranslate, useSidebarState } from 'react-admin'

interface Props {
  dense: boolean
  handleToggle: () => void
  icon: ReactElement
  isOpen: boolean
  name: string
  children: ReactNode
}

const MenuFolder = (props: Props) => {
  const { handleToggle, isOpen, name, children, icon, dense } = props
  const translate = useTranslate()

  const [sidebarIsOpen] = useSidebarState()

  const header = (
    <MenuItem dense={dense} onClick={handleToggle}>
      <ListItemIcon>{icon}</ListItemIcon>
      <Typography
        variant="inherit"
        color="textSecondary"
        sx={{ width: '100%' }}
      >
        {translate(name)}
      </Typography>
      <ListItemIcon>{isOpen ? <ExpandLess /> : <ExpandMore />}</ListItemIcon>
    </MenuItem>
  )

  return (
    <div>
      {sidebarIsOpen && header}
      <Collapse in={!sidebarIsOpen || isOpen} timeout="auto" unmountOnExit>
        <List
          dense={dense}
          component="div"
          disablePadding
          sx={{
            '& .MuiMenuItem-root': {
              transition: 'padding-left 195ms cubic-bezier(0.4, 0, 0.6, 1) 0ms',
              paddingLeft: (theme) =>
                sidebarIsOpen ? theme.spacing(4) : theme.spacing(2)
            }
          }}
        >
          {children}
        </List>
      </Collapse>
    </div>
  )
}

export default MenuFolder
